import React from 'react';
import {
  TextBold,
  TextRegular,
} from '../../styles/GlobalStyledComponents';
import { ImgWrapper } from '../../pages/FinalModal/FinalModalStyledComponents';
import SuccessImg from '../../assets/images/Success/successImg.svg';
import { ButtonsWrapperClose, ContentWrapper, ContentWrapperText, DetailTextWrapper, ModalContainerMobile, ModalImgDivMobile } from './MobileModalStyledComponents';
import Button from '../Button/Button';
import { colors } from '../../styles/Colors';
import { theme } from '../../styles/Theme';

interface MobileModalProps {
  close: () => void;
  mobile_number: string;
}

export const MobileModal: React.FC<MobileModalProps> = ({ close, mobile_number }) => {
  const { red4, white } = colors;
  const { textBold } = theme.fontWeight;

  return (
    <ModalContainerMobile id="mobile-modal-modal">
      <ContentWrapper id="mobile-modal-content-wrapper">
        <DetailTextWrapper id="mobile-modal-text-wrapper">
          <ImgWrapper id="success-img-wrapper">
            <ModalImgDivMobile src={SuccessImg} id="success-image" alt="success image" title="success" width={''} height={''} />
          </ImgWrapper>
          <TextBold fontSize={24} align="center" id="success-title" fontWeight={700} lineHeight={32}>
            Completado
          </TextBold>
        </DetailTextWrapper>
        <ContentWrapperText id="mobile-modal-content">
          <TextRegular id="success-text-mobile-content" fontSize={18} fontWeight={400} lineHeight={24} color="gray6">
            Te vamos a llamar al teléfono <TextRegular fontSize={18} id="success-text-mobile" fontWeight={500} lineHeight={24} color='gray6'>{mobile_number}</TextRegular> el día y la hora correspondiente a tu selección
          </TextRegular>
        </ContentWrapperText>
        <ButtonsWrapperClose id="mobile-modal-button-wrapper">
          <Button
            click={() => close()}
            color={white}
            borderColor={red4}
            backgroundColor={red4}
            fontWeight={textBold}
            id="payment-next-btn payment-main-btn">
            <span>Vuelve atrás</span>
          </Button>
        </ButtonsWrapperClose>
      </ContentWrapper>

    </ModalContainerMobile >
  );
};
